"use client";

import * as React from "react";

function isElementInViewport(el: Element, threshold = 0.85) {
  const r = el.getBoundingClientRect();
  return r.top < window.innerHeight * threshold && r.bottom > 0;
}

export function ScrollReveal() {
  React.useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>("section.section"));

    // Não aplicar no admin e nem em seções que já possuem animação própria
    const targets = els.filter((el) => !el.closest(".adminBg") && !el.classList.contains("benefitsSection") && !el.classList.contains("faqSection"));

    if (targets.length === 0) return;

    // Se não tiver IntersectionObserver, apenas garante visibilidade.
    if (typeof IntersectionObserver === "undefined") {
      for (const el of targets) el.classList.add("srIn");
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            const el = e.target as HTMLElement;
            el.classList.add("srIn");
            el.classList.remove("srPrepared");
            obs.unobserve(el);
          }
        }
      },
      { threshold: 0.18 }
    );

    for (const el of targets) {
      // Não esconda nada que já esteja no viewport no load (evita “sumir” conteúdo)
      if (isElementInViewport(el)) {
        el.classList.add("srIn");
      } else {
        el.classList.add("srPrepared");
        obs.observe(el);
      }
    }

    return () => obs.disconnect();
  }, []);

  return null;
}

